
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Popup, Field, Toast } from 'vant';
import DrawButton from '../components/DrawButton.vue';

Vue.use(Popup).use(Field).use(Toast);

@Component({
  components: {
    DrawButton,
  },
})
export default class LotteryForm extends Vue {
  @Prop() show!: boolean;

  visible = false;

  @Watch('show', { immediate: true })
  onShowChange(val: boolean) {
    this.visible = val;
  }

  @Watch('visible')
  onVisibleChange(val: boolean) {
    if (!val) {
      this.$emit('close');
    }
  }

  handleCancel() {
    this.visible = false;
  }

  handleConfirm() {
    // this.$emit('submit');
    this.visible = false;

  }
}
